import { apiClient } from "./client";
import type { OrganisationSettings } from "@/types";

/**
 * Get organisation settings for the current organisation
 */
export const getOrganisationSettings =
  async (): Promise<OrganisationSettings> => {
    const { data } = await apiClient.get<OrganisationSettings>("/settings");
    return data;
  };
